module.exports = __webpack_public_path__ + "media/images/client/AdContacts/like-3509a4b8621dfd640db6788b73549cfb.svg";